<template>
  <div>
    <base-header class="pb-1">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Corretor</h6>
        </div>
      </div>
    </base-header>
  
    <div class="container-fluid mt--6">
      <card>
        <h3 slot="header" class="mb-0">Corretor</h3>
        <div class="form-row">
          <div class="col-md-12">
            <base-input label="Nome" name="nome" placeholder="Nome" required v-model="broker.name">
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <base-input label="Cpf" name="cpf" placeholder="CPF" required v-model="broker.cpf" mask="###.###.###-##">
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="E-mail" name="email" placeholder="E-mail" required v-model="broker.email" type="email">
            </base-input>
          </div>
          <div class="col-md-2">
            <div class="form-group mb-0">
              <label>Ativo?</label>
              <div class="d-flex align-items-center" style="height: 41px;">
                <el-switch v-model="broker.enabled" active-color="#2C4759" />
              </div>
            </div>
          </div>
        </div>
      </card>
  
      <div class="col-md-12 text-center mb-3">
        <base-button type="primary" @click="save">Salvar</base-button>
        <base-button type="secondary" @click="cancel">{{id ? "Voltar": "Cancelar"}}</base-button>
      </div>
  
      <card v-if="id">
        <h3 slot="header" class="mb-0">Unidades</h3>
        <div class="form-row align-items-end">
          <div class="col-md-12">
            <base-input name="unidade">
              <el-select v-model="selectedCompany" filterable placeholder="Selecione uma unidade" class="w-100">
                <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-12 text-right mb-3">
            <base-button type="primary" @click="linkBrokerToCompany">Vincular</base-button>
          </div>
        </div>
        <div class="mt-4">
          <h4>Unidades Vinculadas</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="company in linkedCompanies" :key="company.id">
                <td>{{ company.name }}</td>
                <td class="text-right">
                  <a href="#!" @click.prevent="unlinkBrokerFromCompany(company.id)"
                    class="table-action table-action-delete" title="Desvincular Corretor da Unidade">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr v-if="linkedCompanies.length === 0">
                <td colspan="2" class="text-center">Nenhuma unidade vinculada</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Switch, Select, Option } from 'element-ui';

export default {
  components: {
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    id: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.loadBroker();
    this.loadCompanies();
  },
  data() {
    return {
      broker: {
        id: null,
        name: '',
        cpf: '',
        email: '',
        enabled: true,
      },
      allCompanies: [],
      companies: [],
      selectedCompany: null,
      linkedCompanies: []
    };
  },
  methods: {
    loadBroker() {
      if (this.id) {
        this.$clubApi.get(`/broker/${this.id}`)
          .then(response => {
            this.broker = response.data.object;
            this.loadLinkedCompanies();
          })
          .catch(this.error)
          .finally(this.done);
      }
    },
    loadCompanies() {
      this.$clubApi.get('/company')
        .then(response => this.allCompanies = this.companies = response.data.object)
        .catch(this.error)
        .finally(this.done);
    },
    loadLinkedCompanies() {
      this.$clubApi.get(`/company/broker/${this.broker.id}`)
        .then(response => {
          this.linkedCompanies = response.data.object;
          this.companies = this.allCompanies.filter(company =>
            !this.linkedCompanies.some(linkedCompany => linkedCompany.id === company.id)
          );
        })
        .catch(this.error)
        .finally(this.done);
    },
    save() {
      let url = '/broker';
      let operation;

      if (this.id) {
        url += `/${this.id}`;
        operation = this.$clubApi.put;
      } else {
        operation = this.$clubApi.post;
      }

      operation(url, this.broker)
        .then(() => {
          this.success('Corretor salvo com sucesso!');
          if (!this.id) {
            location.href = '/configuracoes/corretor';
          }
        })
        .catch(this.error)
        .finally(this.done);
    },
    cancel() {
      location.href = '/configuracoes/corretor';
    },
    linkBrokerToCompany() {
      if (!this.selectedCompany) {
        this.warning('Por favor, selecione uma filial.');
        return;
      }

      this.$clubApi.post(`/company/${this.selectedCompany}/broker/${this.broker.id}`)
        .then(() => {
          this.success('Corretor vinculado à filial com sucesso!');
          this.loadLinkedCompanies();
          this.selectedCompany = null;
          this.selectedCompany = null;
        })
        .catch(this.error)
        .finally(this.done);
    },
    unlinkBrokerFromCompany(companyId) {
      this.$clubApi.delete(`/company/${companyId}/broker/${this.broker.id}`)
        .then(() => {
          this.success('Corretor desvinculado da filial com sucesso!');
          this.loadLinkedCompanies();
        })
        .catch(this.error)
        .finally(this.done);
    },
    done() {
      NProgress.done();
    },
    error(error) {
      this.warning(error.response.data.msg);
    },
    success(message) {
      this.$notify({ type: 'success', message });
    },
    warning(message) {
      this.$notify({ type: 'warning', message });
    }
  }
}
</script>

<style scoped>
.w-100 {
  width: 100%;
}
</style>